// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1anwD","form":"styles_form__3_pTS"};